import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { decisioningEnabledQueryKey } from "../decisioning.keys";

export const useFetchDecisioningEnabled = () => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: decisioningEnabledQueryKey(),
		queryFn: async () =>
			Dtos.Decisioning.Access.Get.Response.schema.parse(
				await get<unknown>("/v2/admin/decisioning/enabled"),
			),
		staleTime: Number.POSITIVE_INFINITY,
	});

	return {
		decisioningEnabled: query.data?.enabled === true,
		decisioningEnabledIsLoading: query.isLoading,
	};
};
